const collectionNavSlider = document.querySelector(".swiper-collection-nav");

const collectionNav = new Swiper(collectionNavSlider, {
  slidesPerView: 2.5,
  spaceBetween: 20,

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    769: {
      slidesPerView: 3.5,
    },
    990: {
      slidesPerView: 7,
    },
  },
});
